const icons = {
  basin: require('Images/Icons/basin.svg'),
  silo: require('Images/Icons/silo.svg'),
  tank: require('Images/Icons/tank.svg')
}

export default icons
